import React from 'react';
import Button from '../../../components/ui/Button';
import { CheckCircle, Users, Shield, CreditCard } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const OnboardingWelcome = ({ userProfile, onNext, loading }) => {
  const features = [
    {
      icon: Users,
      title: 'Professional Service',
      description: 'Access to dedicated support and professional services',
    },
    {
      icon: Shield,
      title: 'Secure Platform',
      description: 'Your data is protected with enterprise-grade security',
    },
    {
      icon: CreditCard,
      title: 'Flexible Billing',
      description: 'Multiple payment options and transparent pricing',
    },
  ];

  return (
    <div className="text-center space-y-6">
      <div className="mb-8">
        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <CheckCircle className="w-8 h-8 text-blue-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Welcome to our platform, {userProfile?.full_name}!
        </h1>
        <p className="text-gray-600">
          We're excited to have you onboard. Let's get you set up with everything you need to get started.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 my-8">
        {features.map((feature, index) => {
          const Icon = feature.icon;
          return (
            <div key={index} className="text-center p-4">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <Icon className="w-6 h-6 text-blue-600" />
              </div>
              <h3 className="font-medium text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-600">{feature.description}</p>
            </div>
          );
        })}
      </div>

      <div className="bg-blue-50 rounded-lg p-6">
        <h3 className="font-medium text-gray-900 mb-2">What's next?</h3>
        <p className="text-sm text-gray-600 mb-4">
          We'll guide you through a quick setup process that should take about 5 minutes. You'll be able to:
        </p>
        <ul className="text-sm text-gray-600 space-y-1 text-left max-w-md mx-auto">
          <li className="flex items-center">
            <CheckCircle className="w-4 h-4 text-green-600 mr-2" />
            Set up your company profile
          </li>
          <li className="flex items-center">
            <CheckCircle className="w-4 h-4 text-green-600 mr-2" />
            Configure billing information
          </li>
          <li className="flex items-center">
            <CheckCircle className="w-4 h-4 text-green-600 mr-2" />
            Verify your account
          </li>
          <li className="flex items-center">
            <CheckCircle className="w-4 h-4 text-green-600 mr-2" />
            Start using our services
          </li>
        </ul>
      </div>

      <div className="flex justify-center pt-6">
        <Button
          onClick={() => onNext({})}
          disabled={loading}
          className="px-8"
        >
          {loading ? 'Loading...' : 'Get Started'}
        </Button>
      </div>
    </div>
  );
};

export default OnboardingWelcome;